// extracted by mini-css-extract-plugin
module.exports = {"adsenseWrapper":"AdInternal_adsenseWrapper__1MT6-"};